//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import subNavSelection from "~/components/header-item-selection";
import BannerTypeProduct from "~/components/content-elements/banner-type-product";
import infiniteSliderIngredients from "~/components/infinite-slider-ingredients";
import triplepl from "~/components/loading-placeholders/triple-pl";
import ProductPresentationHead from "~/components/loading-placeholders/product-presentation-head-pl.vue";
export default {
  components: {
    BannerTypeProduct,
    subNavSelection,
    infiniteSliderIngredients,
    triplepl,
    ProductPresentationHead,
  },
  data() {
    return {
      // slide: 0,
      // sliding: null,
      sliderOptions: {
        // arrows: true,
        // slidesToShow: this.slidesNo,
        // infinite: true,
        // slidesToScroll: 1,
        // adaptiveHeight: true,
        // centerMode: false,
        // dots: false,
        dots: false,
        arrows: true,
        infinite: false,
        focusOnSelect: false,
        initialSlide: 0,
        slidesToShow: 3,
        slidesToScroll: 1,
        touchMove: false,
        centerMode: false,
        // nextArrow:
        //   '<div class="infinite-next-btn"><span class="icon-caret-right tea-product-next mt-3 mt-lg-n4" style="color:#8AA932"></div>',
        // prevArrow:
        //   '<div class="infinite-prev-btn"><span class="icon-caret-left tea-product-prev mt-3 mt-lg-n4" style="color:#8AA932"></span></div>',
        responsive: [
          {
            breakpoint: 2000,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      },
    };
  },

  mounted() {
    this.$store.dispatch("tea-products/getNaturalInfusions"),
      this.$store.dispatch("tea-range/getProductByRange", {
        rangeName: "dilmah_natural_infusion",
      });
  },

  computed: {
    pageData() {
      if (this.$store.state["tea-products"].naturalInfusions != null) {
        return Object.assign(
          this.$store.state["tea-products"].naturalInfusions.our_infusions,
          { links: this.$store.state["tea-products"].naturalInfusions.links }
        );
      }
    },
    dmcData() {
      if (this.$store.state["tea-range"].productByRange != null) {
        return this.$store.state["tea-range"].productByRange;
      }
    },
  },
};
